export function pct(value, decimals, skipLessThan, trimZeroes, hideSign) {
  decimals = decimals || 0;
  if (!skipLessThan && value * 100 < 1 && value * 100 > 0) {
    if (!hideSign) {
      return `<1%`;
    } else {
      return `<1`;
    }
  } else {
    let display = (value * 100).toFixed(decimals);
    if (trimZeroes) {
      display = display.replace(/\.0/gi, '');
    }

    if (!hideSign) {
      display += '%';
    }

    return `${ display }`;
  }
}

export function pad(n) {
  return (n < 10 ? '0' : '') + n;
}

export function getNumberWithOrdinal(n) {
  let s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function groupBy(xs, key) {
  return xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}


export function isBetween(value, start, end) {
  if (value >= start && value <= end) {
    return true;
  } else {
    return false;
  }
}

export function getLastItem(arr) {
  return arr[arr.length - 1];
}

export function getOffset(element)
{
  if (!element.getClientRects().length)
  {
    return { top: 0, left: 0 };
  }

  let rect = element.getBoundingClientRect();
  let win = element.ownerDocument.defaultView;
  return (
    {
      top: rect.top + win.pageYOffset,
      left: rect.left + win.pageXOffset
    });
}

export function overlaps(el1, el2) {
  const domRect1 = el1.getBoundingClientRect();
  const domRect2 = el2.getBoundingClientRect();

  return !(
    domRect1.top > domRect2.bottom ||
    domRect1.right < domRect2.left ||
    domRect1.bottom < domRect2.top ||
    domRect1.left > domRect2.right
  );
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function pluralize(string, value) {
  if (value > 1 || value === 0) {
    string += `s`;
  }
  return string;
}
